import { createApi } from '@reduxjs/toolkit/query/react';

import { AllDataResponseDto, DeleteParamsDto, DeleteStatusDto, PaginatedResponse, UserMin } from '../common/dto/common.dto';
import { ExceptionRuleCreateDto, ExceptionRuleUpdateDto, ExceptionRuleViewDto } from '../common/dto/exception-rule.dto';
import { FilterDto } from '../common/dto/filter.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_DATA_COLLECTION_SERVICE;
const TAG_TYPE = 'ExceptionRule';

export const exceptionRuleApi = createApi({
  reducerPath: 'exceptionRuleApi',
  baseQuery: customFetchBase(`${API_URI}/api/exception-rule`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    searchExceptionRule: builder.mutation<PaginatedResponse<ExceptionRuleViewDto>, Partial<FilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getAssignedUserForExceptionRule: builder.mutation<AllDataResponseDto<UserMin>, Partial<string>>({
      query(locationId) {
        return {
          url: 'get-assigned-users',
          method: 'PATCH',
          body: { locationId },
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getNotifyUserForExceptionRule: builder.mutation<AllDataResponseDto<UserMin>, Partial<string>>({
      query(locationId) {
        return {
          url: 'get-notify-users',
          method: 'PATCH',
          body: { locationId },
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getExceptionRule: builder.query<ExceptionRuleViewDto, string>({
      query: (id: string) => {
        return `${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    addExceptionRule: builder.mutation<ExceptionRuleViewDto, Partial<ExceptionRuleCreateDto>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    updateExceptionRule: builder.mutation<ExceptionRuleViewDto, Partial<ExceptionRuleUpdateDto>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    deleteExceptionRule: builder.mutation<DeleteStatusDto, DeleteParamsDto>({
      query(data: DeleteParamsDto) {
        return {
          url: data.id,
          method: 'DELETE',
          body: data.params ?? {},
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const {
  useSearchExceptionRuleMutation,
  useGetExceptionRuleQuery,
  useAddExceptionRuleMutation,
  useUpdateExceptionRuleMutation,
  useDeleteExceptionRuleMutation,
  useGetAssignedUserForExceptionRuleMutation,
  useGetNotifyUserForExceptionRuleMutation,
} = exceptionRuleApi;
